import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function ConfirmationModal({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
  confirmLabel,
  cancelLabel,
  isError,
  stylingPreset = null
}) {

  const appConfig = typeof window !== "undefined" ? window.appConfig || {} : {};
  const modalStyles = appConfig.modalStyles || {};
  const preset = stylingPreset && modalStyles[stylingPreset] ? modalStyles[stylingPreset] : null;

  const effective = {
    ...(preset || {}),
  };

  let titleStyle = "";
  if (effective.headerBackgroundColor) titleStyle += effective.headerBackgroundColor;
  if (effective.headerTextColor) titleStyle += (titleStyle ? " " : "") + effective.headerTextColor;
  if (effective.headerCentered) titleStyle += " d-flex justify-content-center align-items-center position-relative";

  let bodyStyle = "";
  if (effective.bodyPadding) bodyStyle += effective.bodyPadding;
  if (effective.bodyCentered) bodyStyle += (bodyStyle ? " " : "") + "d-flex flex-column justify-content-center align-items-center position-relative";

  let singleButtonStyle = effective.singleButtonColor || "";
  if (effective.singleButtonTextColor) singleButtonStyle += (singleButtonStyle ? " " : "") + effective.singleButtonTextColor;

  const footerStyle = isError
    ? effective.singleButtonCentered
      ? "d-flex justify-content-center align-items-center position-relative"
      : "d-flex justify-content-between"
    : "d-flex justify-content-between";


  return (
    <Modal backdrop="static" keyboard={false} isOpen={isOpen} toggle={onCancel}>
      <ModalHeader
        className={titleStyle}
        toggle={effective.closeButton ? onCancel : null}
        close={
          effective.closeButton
            ? (
              <FontAwesomeIcon
                color="black"
                icon="times"
                size="2x"
                onClick={onCancel}
                role="button"
                style={{ cursor: "pointer" }}
              />
            )
            : null
        }
      >
        {title}
      </ModalHeader>

      <ModalBody className={bodyStyle}>{message}</ModalBody>

      <ModalFooter className={footerStyle}>
        {isError ? (
          <Button className={singleButtonStyle} active={false} disabled={false} onClick={onCancel}>
            {confirmLabel}
          </Button>
        ) : (
          <>
            <Button className={effective.negativeButtonColor} active={false} disabled={false} onClick={onCancel}>
              {cancelLabel}
            </Button>
            <Button className={effective.positiveButtonColor} active={false} disabled={false} onClick={onConfirm}>
              {confirmLabel}
            </Button>
          </>
        )}
      </ModalFooter>
    </Modal>
  );
}

export default ConfirmationModal;
